import { localStorage } from '@muse-web/storages'
import type { TSession } from '../types/sessionTypes'

const SESSION_KEY = 'next-auth.session-token'

const isSession = (session: unknown): session is TSession =>
    !!session && typeof session === 'object' && 'token' in session && 'user' in session

export const getSessionFromLocalStorage = (): TSession | null => {
    const session = localStorage.get(SESSION_KEY)
    return isSession(session) ? session : null
}

export const setSessionToLocalStorage = (session: TSession | null) => {
    if (session) {
        localStorage.set(SESSION_KEY, session)
    } else {
        localStorage.remove(SESSION_KEY)
    }
}

export const removeSessionFromLocalStorage = () => {
    localStorage.remove(SESSION_KEY)
}
